var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "157.57mm",
    height: "54.78mm",
    viewBox: "6830 6668 15757 5478",
    preserveAspectRatio: "xMidYMid",
    fillRule: "evenodd",
    strokeWidth: 28.222,
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsOoo: "http://xml.openoffice.org/svg/export",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsPresentation: "http://sun.com/xmlns/staroffice/presentation",
    xmlnsSmil: "http://www.w3.org/2001/SMIL20/",
    xmlnsAnim: "urn:oasis:names:tc:opendocument:xmlns:animation:1.0",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    className: "EmbeddedBulletChars"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-57356",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 580,1141 L 1163,571 580,0 -4,571 580,1141 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-57354",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8,1128 L 1137,1128 1137,0 8,0 8,1128 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-10146",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 174,0 L 602,739 174,1481 1456,739 174,0 Z M 1358,739 L 309,1346 659,739 1358,739 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-10132",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2015,739 L 1276,0 717,0 1260,543 174,543 174,936 1260,936 717,1481 1274,1481 2015,739 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-10007",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,-2 C -7,14 -16,27 -25,37 L 356,567 C 262,823 215,952 215,954 215,979 228,992 255,992 264,992 276,990 289,987 310,991 331,999 354,1012 L 381,999 492,748 772,1049 836,1024 860,1049 C 881,1039 901,1025 922,1006 886,937 835,863 770,784 769,783 710,716 594,584 L 774,223 C 774,196 753,168 711,139 L 727,119 C 717,90 699,76 672,76 641,76 570,178 457,381 L 164,-76 C 142,-110 111,-127 72,-127 30,-127 9,-110 8,-76 1,-67 -2,-52 -2,-32 -2,-23 -1,-13 0,-2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-10004",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 285,-33 C 182,-33 111,30 74,156 52,228 41,333 41,471 41,549 55,616 82,672 116,743 169,778 240,778 293,778 328,747 346,684 L 369,508 C 377,444 397,411 428,410 L 1163,1116 C 1174,1127 1196,1133 1229,1133 1271,1133 1292,1118 1292,1087 L 1292,965 C 1292,929 1282,901 1262,881 L 442,47 C 390,-6 338,-33 285,-33 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-9679",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 813,0 C 632,0 489,54 383,161 276,268 223,411 223,592 223,773 276,916 383,1023 489,1130 632,1184 813,1184 992,1184 1136,1130 1245,1023 1353,916 1407,772 1407,592 1407,412 1353,268 1245,161 1136,54 992,0 813,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-8226",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 346,457 C 273,457 209,483 155,535 101,586 74,649 74,723 74,796 101,859 155,911 209,963 273,989 346,989 419,989 480,963 531,910 582,859 608,796 608,723 608,648 583,586 532,535 482,483 420,457 346,457 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-8211",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4,459 L 1135,459 1135,606 -4,606 -4,459 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bullet-char-template-61548",
    transform: "scale(0.00048828125,-0.00048828125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 173,740 C 173,903 231,1043 346,1159 462,1274 601,1332 765,1332 928,1332 1067,1274 1183,1159 1299,1043 1357,903 1357,740 1357,577 1299,437 1183,322 1067,206 928,148 765,148 601,148 462,206 346,322 231,437 173,577 173,740 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Page"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 6830,
    y: 8109,
    width: 3467,
    height: 4037
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,166,80)",
    stroke: "none",
    d: "M 9555,12075 L 9350,11546 9323,11546 C 9144,11771 8961,11927 8772,12014 8583,12101 8337,12144 8033,12144 7660,12144 7367,12037 7152,11824 6938,11611 6831,11308 6831,10914 6831,10502 6975,10198 7264,10002 7552,9806 7987,9698 8568,9677 L 9243,9656 9243,9486 C 9243,9092 9041,8895 8638,8895 8327,8895 7963,8989 7543,9176 L 7192,8461 C 7639,8227 8135,8110 8680,8110 9201,8110 9601,8223 9879,8450 10157,8677 10296,9022 10296,9486 L 10296,12075 9555,12075 Z M 9243,10275 L 8833,10288 C 8524,10298 8295,10353 8144,10455 7994,10557 7919,10712 7919,10921 7919,11220 8090,11369 8433,11369 8678,11369 8875,11298 9022,11157 9169,11016 9243,10828 9243,10594 L 9243,10275 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 10829,
    y: 8190,
    width: 4050,
    height: 3886
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,166,80)",
    stroke: "none",
    d: "M 12309,12075 L 10829,8190 11938,8190 12688,10404 C 12772,10684 12824,10949 12845,11199 L 12865,11199 C 12877,10977 12929,10712 13022,10404 L 13769,8190 14877,8190 13397,12075 12309,12075 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 15386,
    y: 6668,
    width: 1156,
    height: 5409
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,30,30)",
    stroke: "none",
    d: "M 15387,7186 C 15387,6841 15579,6668 15964,6668 16348,6668 16541,6841 16541,7186 16541,7350 16493,7478 16396,7570 16300,7661 16156,7707 15964,7707 15579,7707 15387,7533 15387,7186 Z M 16492,12075 L 15432,12075 15432,8190 16492,8190 16492,12075 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 17604,
    y: 8117,
    width: 3588,
    height: 3960
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(32,30,30)",
    stroke: "none",
    d: "M 21190,12075 L 20130,12075 20130,9806 C 20130,9526 20081,9315 19981,9175 19881,9035 19723,8965 19505,8965 19208,8965 18994,9064 18862,9262 18730,9460 18664,9788 18664,10247 L 18664,12075 17604,12075 17604,8190 18414,8190 18556,8687 18615,8687 C 18733,8499 18896,8357 19104,8261 19311,8165 19547,8117 19811,8117 20262,8117 20605,8239 20839,8484 21073,8728 21190,9081 21190,9542 L 21190,12075 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "com.sun.star.drawing.ClosedBezierShape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "BoundingBox",
    stroke: "none",
    fill: "none",
    x: 16929,
    y: 7379,
    width: 5658,
    height: 4417
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,166,80)",
    stroke: "none",
    d: "M 18637,10659 L 17502,9495 16929,10040 18651,11795 22585,7891 22038,7379 C 21865,7512 21766,7580 21587,7740 L 18637,10659 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvin);
export default __webpack_public_path__ + "static/media/avin.eb58238480a29024f76ac3bf575c127f.svg";
export { ForwardRef as ReactComponent };